import React from 'react';
import Dropzone from 'react-dropzone'
import ReactGA from 'react-ga';
import { connect } from 'react-redux'
import { fetchEvent, editResults } from '../../actions'
import { uploadArtifact } from './eventUtils/eventUploadUtils'
import { hasNoEditEvent } from '../helpers/EventUtils'
import { UPLOAD_IMAGE, GA_TRACKING_UPLOAD_RESULTS_PAGE } from '../helpers/AppConsts'
import { uploadTypes } from '../helpers/AppConsts'


class EventResults extends React.Component {
  
  componentDidMount(){
    ReactGA.ga('send', 'pageview', {GA_TRACKING_UPLOAD_RESULTS_PAGE});
    this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_organizer);
  }
 
  renderEvent() {
    return  (
      <div className="content">
        <div className="header"><h2>Event_Name: {this.props.edits.editEvent.event_name}</h2></div>
      </div>
    )
  }

  onDrop = (files) =>{
    uploadArtifact(files, this.props.edits.editEvent, this.props.editResults, uploadTypes.RESULTS_UPLOAD)
  }  

  renderLoadingDesc = () => {
    return (
      <div className="ui container">
        <h2>Upload Results File</h2>
        Loading..          
      </div>
    );
  }
  
  renderDropZoneComp = () => {
    return (
      <Dropzone onDrop={this.onDrop}>  
              {({getRootProps, getInputProps}) => (
                <div {...getRootProps({className: 'dropzone'})}>
                  <input {...getInputProps()} />
                  <p>Drag 'n' drop results file here, or click to select files
                  <img alt="placeholder" src={UPLOAD_IMAGE} className="ui medium image" />
                  </p>
                </div>
              )}
      </Dropzone> 
    )
  }

  renderDragNDropOption = () => {
    return (
      <div className="ui container">
        <h2>Upload Results File</h2>
        {this.renderEvent()}
        {this.renderDropZoneComp()}          
      </div>
    );
  }

  render () {
    return hasNoEditEvent(this.props.edits) ? this.renderLoadingDesc(): this.renderDragNDropOption();
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    edits: state.edits,
    currentUserEmail: state.auth.userEmail
  };
}
export default connect(mapStateToProps, {fetchEvent,editResults})(EventResults)

